import { useLang } from "../i18n";
import { Chapter } from "./Reveal";

export function GlobalMarkets() {
  const { t } = useLang();
  return (
    <section data-testid="markets-section" className="relative py-24 md:py-32 overflow-hidden">
      <div aria-hidden="true" className="absolute inset-0 overflow-hidden">
        <img src="/assets/logistics.webp" alt="" loading="lazy" decoding="async" className="h-full w-full object-cover" />
        <div className="absolute inset-0 bg-[#07111F]/80" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#07111F] via-transparent to-[#07111F]" />
      </div>
      <div className="relative mx-auto max-w-7xl px-5 md:px-8">
        <Chapter kicker={t.markets.kicker} title={t.markets.title} subtitle={t.markets.subtitle} testId="markets" />
      </div>
    </section>
  );
}
